import React, { useContext } from 'react'
import { Modal, View } from 'oio-react'
import { Route, useHistory, useRouteMatch } from 'react-router-dom'
import InitiativeFileLibrary from 'src/apps/Files/components/InitiativeFileLibrary'
import FolderView from 'src/apps/Files/components/FolderView'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const InitiativeFiles = () => {
   const history = useHistory()
   const match = useRouteMatch()
   const { initiative } = useContext(InitiativeHierarchyContext)

   return (
      <View float="left" width="100%">
         <InitiativeFileLibrary initiativeId={initiative.id} />
         <Route path={`${match.url}/folder/:containerId`}>
            <Modal
               backgroundColor="#fff"
               width="100%[a-b] 90%[c] 700px[d-f]"
               height="100%[a-b] 80%[c-f]"
               borderRadius="5px"
               onCloseTrigger={() => history.push(match.url)}
               overlayBackgroundColor="rgba(80,80,80, 0.97)"
               open>
               <FolderView
                  initiativeId={initiative.id}
                  onCloseButtonClick={() => history.push(match.url)}
               />
            </Modal>
         </Route>
      </View>
   )
}

export default InitiativeFiles
